var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphChecked = function SvgInterfaceGlyphChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.412 20.5q-.589 0-1-.413A1.37 1.37 0 0 1 3 19.083V4.917q0-.59.412-1.004a1.36 1.36 0 0 1 1-.413h14.117q.33 0 .6.142.27.141.436.33l-1.036 1.04v-.095H4.412v14.166h14.117v-8.098l1.412-1.417v9.515q0 .59-.412 1.004a1.36 1.36 0 0 1-1 .413zm6.612-3.967L5.8 11.292l.988-.992 4.236 4.25 8.988-9.02.988.992z"
  })));
};
export default SvgInterfaceGlyphChecked;